import { ColumnDef } from '@tanstack/react-table'
import { ILegalPerson, IRenderInputs } from '../models/models'
import Status from '../components/UI/Status'
import { legalPersonsInputs } from './legalPersonsPage'
import dateFormat from 'dateformat'

export const fopsColumns: ColumnDef<ILegalPerson>[] = [
	{
		accessorKey: 'status',
		header: 'Статус',
		cell: (value) => <Status type={value.getValue<any>()} />,
	},
	{
		accessorKey: 'name',
		header: 'ПІБ',
		minSize: 300,
	},
	{
		accessorKey: 'directorPhone',
		header: 'Номер телефону',
		enableSorting: false,
	},
	{
		accessorKey: 'directorEmail',
		header: 'E-mail',
		enableSorting: false,
		minSize: 200,
	},
	{
		accessorKey: 'registeredAt',
		header: 'Дата реєстрації',
		cell: (value) => dateFormat(value.getValue<any>(), 'dd.mm.yyyy'),
	},
	{
		accessorKey: 'balance',
		header: 'Баланс',
		cell: (value) => Number(value.getValue<any>()) / 100,
	},
	{
		accessorKey: 'code',
		header: 'РНОКПП',
		enableSorting: false,
	},
	{
		accessorKey: 'directorBirthdate',
		header: 'Дата народження',
		cell: (value) => dateFormat(value.getValue<any>(), 'dd.mm.yyyy'),
	},
	{
		accessorKey: 'address',
		header: 'Адреса',
		enableSorting: false,
		minSize: 300,
	},
	{
		accessorKey: 'region',
		header: 'Регіон',
		cell: (value) => value.row.original.region.name,
	},
]

export const fopsInputsData: IRenderInputs<legalPersonsInputs>[] = [
	{
		name: 'name',
		type: 'text',
		placeholder: 'ПІБ',
	},
	{
		name: 'address',
		type: 'text',
		placeholder: 'Адреса',
	},
	{
		name: 'directorLastname',
		type: 'text',
		placeholder: 'Прізвище директора',
	},
	{
		name: 'directorEmail',
		type: 'text',
		placeholder: 'E-mail',
	},
	{
		name: 'directorName',
		type: 'text',
		placeholder: "Ім'я директора",
	},
	{
		name: 'directorPhone',
		type: 'text',
		placeholder: 'Номер телефону',
	},
	{
		name: 'directorSurname',
		type: 'text',
		placeholder: 'По батькові директора',
	},
	{
		name: 'directorBirthdate',
		type: 'date',
		placeholder: 'Дата народження',
	},
	{
		name: 'bank',
		type: 'text',
		placeholder: 'Банк',
	},
	{
		name: 'code',
		type: 'text',
		placeholder: 'РНОКПП',
	},
	{
		name: 'overdraftAmount',
		type: 'number',
		step: 0.01,
		placeholder: 'Сума овердрафту',
	},
	{
		name: 'lowerLimit',
		type: 'number',
		step: 0.01,
		placeholder: 'Граничне значення на балансі',
	},
	{
		name: 'discountPerLiter',
		type: 'number',
		step: 0.01,
		placeholder: 'Знижка грн/л',
	},
]
